export var EVENTS = {
	SAVE: 'SAVE'
}